import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PageGate from "@/components/PageGate";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import OrganizerPage from "@/pages/OrganizerPage";
import WebsitesPage from "@/pages/WebsitesPage";
import SocialPage from "@/pages/SocialPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminPage from "@/pages/AdminPage";
import AccountPage from "@/pages/AccountPage";
import OnboardingPage from "@/pages/OnboardingPage";
import PoliciesPage from "@/pages/PoliciesPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import TwoPointOhPage from "@/pages/TwoPointOhPage";

function ScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    document.title = "Business Aligned — Every business, beautifully organized";
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
        <BrowserRouter>
          <ScrollReset />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/organizer" element={<OrganizerPage />} />
            <Route path="/websites" element={<PageGate page="websites"><WebsitesPage /></PageGate>} />
            <Route path="/social" element={<PageGate page="social" fallback="/inquire"><SocialPage /></PageGate>} />
            <Route path="/inquire" element={<SocialPage inquiryOnly />} />
            <Route path="/2-0" element={<PageGate page="two_point_oh"><TwoPointOhPage /></PageGate>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
          <Footer />
          <Toaster theme="light" position="bottom-right" toastOptions={{ style: { background: "#FFFDF7", color: "#3A2E25", border: "1px solid #E8DCCB" } }} />
        </BrowserRouter>
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}
